import { ApiError } from '@/lib/api';

import { ConviteDasBoasVindas } from '@alianca/core/contracts/onboarding';

import type { DadosCadastro } from '@alianca/core/contracts/identidade';

// Cliente de auth (T07 F2, T02 §3.10): fetch same-origin em /api/auth/*, sem dependência nova.
// Os endpoints do Better Auth erram com { code, message }; os próprios, com o envelope { success:false, error, code }.
// Os dois viram ApiError, como no api().

type Corpo = Record<string, unknown> | null;

function comoApiError(res: Response, json: Corpo): ApiError {
    const code = typeof json?.code === 'string' ? json.code : 'internal';
    const texto = json?.error ?? json?.message;
    return new ApiError(res.status, code, typeof texto === 'string' ? texto : res.statusText, json);
}

async function postAuth(caminho: string, body?: Record<string, unknown>): Promise<Corpo> {
    const res = await fetch(`/api/auth${caminho}`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: body ? { 'Content-Type': 'application/json' } : undefined,
        body: body ? JSON.stringify(body) : undefined,
    });
    const json = (await res.json().catch(() => null)) as Corpo;
    if (!res.ok) throw comoApiError(res, json);
    return json;
}

export interface Convite {
    token: string;
    password: string;
}

export async function entrar(email: string, senha: string): Promise<void> {
    await postAuth('/sign-in/email', { email, password: senha });
}

export async function sair(): Promise<void> {
    await postAuth('/sign-out');
}

/** Resposta sempre genérica (não enumera e-mails). */
export async function esqueciSenha(email: string): Promise<string> {
    const json = await postAuth('/esqueci-senha', { email });
    return typeof json?.message === 'string' ? json.message : '';
}

export async function redefinirSenha(token: string, novaSenha: string): Promise<void> {
    await postAuth('/reset-password', { token, newPassword: novaSenha });
}

/** Com `convite`: link de convite (sem sessão, define a senha e já entra). Sem: sessão com cadastro incompleto. */
export async function concluirCadastro(dados: DadosCadastro, convite?: Convite): Promise<void> {
    await postAuth('/complete-registration', { ...convite, ...dados });
}

/** Os dados com que o representante entra, lidos pelo token do convite (sem consumir). */
export async function lerConviteDasBoasVindas(token: string): Promise<ConviteDasBoasVindas> {
    return ConviteDasBoasVindas.parse(await postAuth('/boas-vindas/convite', { token }));
}

export async function iniciarImpersonacao(userId: string): Promise<void> {
    await postAuth('/impersonacao/iniciar', { user_id: userId });
}

export async function encerrarImpersonacao(): Promise<void> {
    await postAuth('/impersonacao/encerrar');
}
